import { Switch } from "antd";
import { ElementType } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

export const StyledLinkAccount = styled(Link)`
    display: flex;
    align-items: flex-start;
    gap: 12px;
    color: ${({ theme }) => theme.primaryTypographyColor};

    &:hover {
        color: inherit;
    }
`;

export const StyledTwoColumnsGrid = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
    align-items: center;
`;

export const StyledSwitch = styled(Switch)`
    width: fit-content;
    margin-left: auto;
`;

export const StyledIcon = styled.span<{ as?: ElementType }>`
    font-size: 16px;
`;
